<template>
  <div class="appealInfo" style="text-align: center;">
    <h3 style="color: green;">申诉成功!</h3>
    <p style="color: gray;">我们收到您的申请后，将在3个工作日给您答复。</p>
    <p style="color: gray;">若有疑问，请联系客服:400-700-5305咨询进度。</p>
  </div>
</template>

<script>
  import {
    Dialog
  } from 'vant';
    import { mySessionStorage } from '@/utils/storage.js'
  export default {
    name: "appealInfo",
    data() {
      return {
        type: 0, //0 拍照 1申诉
        title: "",
        openid:""
      };
    },
    methods: {
      onClickLeft() {
        console.log("返回");
        this.$router.push("/menu");
      },

      getCarNum(carNum) {
        console.log(carNum);
        this.carNum = carNum;
      },

      appeal() {

      },
    },
    created() {
      this.openid = mySessionStorage.getItem("openid");
    }
  };
</script>

<style scoped>
  .bindCar {
    min-height: 100%;
    height: 200%;
    width: 100%;
    max-width: 100%;
    background-color: #e8e9eb;
    float: left;
  }

  .adsense_space {
    width: 100%;
    height: 25%;
  }

  .adsense_space img {
    height: 100%;
    width: 100%;
  }

  .bt_bind {
    width: 80%;
    margin: 30px 10%;
    border-radius: 5px;
    height: 36px;
    /* position: fixed;
  display: block; */
  }

  .appealInfo {
    text-align: center;
    margin: 15% 3%;
  }

  .car-info {
    margin: 0 4%;
  }

  .info {
    text-align: center;
    height: 36px;
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/bind/appealInfo.vue